import React, { Fragment } from "react";
import HeaderCartButton from "./HeaderCartButton";

import image from "../../assets/meals.jpg";
import classes from "./Header.module.css";

const Header = (props) => {
  return (
    <Fragment>
      <header className={classes.header}>
        <h1>Une petite faim ? </h1>
        <HeaderCartButton onClick={props.onShowCart} />
      </header>
      <div className={classes['main-image']}>
        <img src={image} alt=""></img>
      </div>
    </Fragment>
  );
};

export default Header;
